import _ from "lodash";
import countryJson from "../../jsons/countries.json";
import groupTypeJson from "../../jsons/groupType.json";
import stateJson from "../../jsons/states.json";
import indianStateJson from "../../jsons/indianState.json";
import slipType from "../../jsons/slipType.json";
import pType from "../../jsons/patientType.json";
import vType from "../../jsons/visitType.json"
import PaymentType from "../../jsons/paymentType.json";
import patientCategory from "../../jsons/patientCategory.json";
import referralCode from "../../jsons/referralCode.json";

export const Countries = [...countryJson];
export const States = [...stateJson];
export const IndianStates = [...indianStateJson];
export const patientType = [...pType];
export const visitType = [...vType];
export const SlipType = [...slipType];
export const groupType = [...groupTypeJson];
export const PaymentTypes = [...PaymentType];
export const PatientCategory = [...patientCategory];
export const ReferralCode = [...referralCode];
export const gstTypeList = [
    {name: "Unregistered Consumer", value: "Unregistered"},
    {name: "Registered Consumer", value: "Registered"},
];
export const gender = [
    {name: "Male", value: "male"},
    {name: "Female", value: "female"},
];

export const branchType = [
    {
        name: "Head Branch",
        key: "headBranch",
    },
    {
        name: "Branch",
        key: "branch",
    },
];

export const category = [
    {
        name: "SOUPS",
        key: "soups",
        index: 1
    },
    {
        name: "CONTINENTAL",
        key: "continental",
        index: 2
    },
    {
        name: "CHINESE",
        key: "chinese",
        index: 3
    },
    {
        name: "INDIAN",
        key: "indian",
        index: 4
    },
    {
        name: "DESSERTS",
        key: "desserts",
        index: 5
    },
    {
        name: "BEVERAGES",
        key: "beverages",
        index: 6
    },
    {
        name: "CLUB-MENU",
        key: "club-menu",
        index: 7
    },
];
export const categoryType = [
    {
        name: "Half",
        key: "half",
    },
    {
        name: "Full",
        key: "full",
    },

];
export const getStateByCountry = (countryName) => {
    let findCountry = _.find(countryJson, (item) => {
        return item.name === countryName;
    });
    if (findCountry) {
        let stateList = _.filter(stateJson, (item) => {
            return item.country_id === findCountry.id;
        });
        return stateList;
    } else {
        return [];
    }
};
export const monthYearPicker = (data) => {
    // data = data.toString()
    data = data.replace("/", "").replace(/[^\d]/, "");
    let month = data.substring(0, 2);
    let year = data.substring(2, 6);
    let date = "";
    if (month) {
        date = date + month;
    }
    if (year) {
        year = "/" + year;
    }
    return `${date}${year}`;
};
export const KotType = [
    {
        name: "Kitchen",
        key: "kitchen",
        index: 1,
    },
   /* {
        name: "Tandoor",
        key: "tandoor",
        index: 2,
    },*/
    {
        name: "BEVERAGES",
        key: "beverages",
        index: 3,
    },
];

export const subCategoryType = [
    {
        name: "Kitchen",
        key: "kitchen",
        index: 1,
    },
    {
        name: "Tandoor",
        key: "tandoor",
        index: 2,
    },
];

export const TABLE_MAP = {
    m: "Mehfil",
    mo: "Mehfil Outdoor",
    d: "Darbaar",
    st: "Sultanat",
    ic: "Ilahi Club",
    id: "Ilahi Outdoor",
    r: "Rooms",
    z: "Zomato",
    g: "Guest",
    hod: "HOD",
    md: "MD",
};

